import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren,
} from '@angular/core';

@Component({
  selector: 'app-primary-column-selection',
  templateUrl: './primary-column-selection.component.html',
  styleUrl:
    '../secondary-column-selection/secondary-column-selection.component.scss',
})
export class PrimaryColumnSelectionComponent implements OnInit {
  @Input() visible: boolean;
  @Input() placeholder: String;
  @Input() items: Array<object>;
  @Input() listStyle: any;
  @Input() maxSelection: number = -1;
  @Input() name: string = 'demo';
  @Input() search: boolean = true;
  @Input() scroll: any = 'native';
  @Input() styleClass: any = 'search-list';
  @Input() controlType: string = 'checkbox';
  @Input() enableSelectAll: boolean = false;
  @Input() searchIcon: boolean = false;
  @Input() resetBehaviour: boolean = false;
  @Input() selectedValue: Array<object> = [];

  @Output() onItemSelect = new EventEmitter();
  @Output() onMaxSelection = new EventEmitter();
  @Output() onSelectAll = new EventEmitter();
  @Output() closeSidebar = new EventEmitter();
  @Output() onLoadSelect = new EventEmitter();
  @Output() onResetSelect = new EventEmitter();
  @Output() onItemChecked = new EventEmitter();

  filteredItems: Array<object>;
  selectedCheckBox: any;
  selectedItemLabel: any;
  selectAllBinary: boolean = false;
  @ViewChildren('checkboxes1') checkboxes1: QueryList<ElementRef>;
  @ViewChildren('radioboxes1') radioboxes1: QueryList<ElementRef>;
  @ViewChild('myInput') myInputRef: ElementRef;
  ngOnInit() {
    this.assignCopy();
  }
  constructor(public cdr: ChangeDetectorRef) {}
  ngOnChanges(changes: SimpleChanges) {
    if (changes['visible'] && changes['visible'].currentValue === true) {
      this.ngOnInit();
    }
    if (this.resetBehaviour) {
      this.assignCopy();
      if (this.checkboxes1) {
        this.resetCheckList();
      }
    }
  }
  public clearFilterText() {
    if (this.myInputRef && this.myInputRef.nativeElement) {
      this.myInputRef.nativeElement.value = '';
    }
  }
  public resetCheckList() {
    if (this.controlType !== 'radio') {
      this.checkboxes1.forEach((element) => {
        element.nativeElement.checked = false;
      });
      this.assignCopy();
    }
    this.selectedValue.length = 0;
    this.cdr.detectChanges();
    this.onItemSelect.emit(this.selectedValue);
  }

  public assignCopy() {
    this.filteredItems = Object.assign([], this.items);
  }
  assignDynamicId(_item: any, i: number) {
    return this.name + '-' + _item.label + i;
  }

  getSelection(e: any) {
    if (!this.checkMaxSelection(e)) {
      if (e.target.checked) {
        let index = this.items.findIndex(
          (item: any) => item.label == e.target.value
        );
        this.selectedValue.push(this.items[index]);

        this.selectedItemLabel = this.items[index]['label'];
      } else {
        let ind = this.selectedValue.findIndex(
          (item: any) => item.label === e.target.value
        );
        this.selectedValue.splice(ind, 1);
      }
    } else {
      this.onMaxSelection.emit(this.selectedValue);
    }
    this.onItemSelect.emit(this.selectedValue);
    //to check uncheck select All based on selection is selet all is enabled
    if (this.enableSelectAll) {
      if (this.selectedValue.length === this.items.length) {
        //deseleecting select all checkbox
        this.checkboxes1.first.nativeElement.checked = true;
        this.selectAllBinary = true;
      } else {
        this.checkboxes1.first.nativeElement.checked = false;
        this.selectAllBinary = false;
      }
    }
  }
  checkMaxSelection(e: any) {
    if (
      this.selectedValue.length >= this.maxSelection &&
      e.target.checked &&
      this.maxSelection !== -1
    ) {
      e.target.checked = false;
      e.preventDefault();
      e.stopPropagation();
      return true;
    } else {
      return false;
    }
  }

  hideSlideBar(e) {
    this.closeSidebar.emit(e);
  }
  resetColumn(e) {
    this.onResetSelect.emit(e);
  }
  applyColumn(e) {
    this.onLoadSelect.emit(e);
  }
  setAllBinaryTrue(data, bool) {
    data.forEach((item) => {
      item.binary = bool; // Set binary to true for each object
    });
    return data;
  }
  getBinaryTrueElements(data) {
    const result = []; // Initialize an empty array to store the elements
    data.forEach((item) => {
      if (item.binary === true) {
        // Check if binary is true
        result.push(item); // Push the element to the result array
      }
    });
    return result;
  }
  onSelectAllClick(e: any) {
    let bool = e.currentTarget.checked;
    this.selectAllBinary = bool;
    // this.checkboxes1.forEach((element) => {
    //   element.nativeElement.checked = bool;
    // });
    // this.onSelectAll.emit(bool);
    // this.triggerAllSelection(bool);
    // this.syncSelectedValue(); //force sync up
    this.filteredItems = this.setAllBinaryTrue(this.filteredItems, bool);
    this.selectedValue = this.getBinaryTrueElements(this.filteredItems);
  }
  updateSelectedItems(e: any) {
    let index = this.items.findIndex(
      (item: any) => item.label == e.target.value
    );
    if (e.target.checked) {
      this.selectedCheckBox = this.items[index];
      this.selectedCheckBox.checkedStatus = true;
      this.onItemChecked.emit(this.selectedCheckBox);
      this.selectedItemLabel = this.items[index]['label'];
    } else {
      this.selectedCheckBox = this.items[index];
      this.selectedCheckBox.checkedStatus = false;
      this.onItemChecked.emit(this.selectedCheckBox);
    }
  }
  triggerAllSelection(_bool: boolean) {
    if (_bool) {
      this.items.forEach((val: any) => {
        let idx = this.selectedValue.findIndex(
          (item: any) => item.label === val.label
        );
        if (idx == -1) {
          let obj: any = val;
          obj.binary = _bool; //assign _bool instead of false
          obj.checkedStatus = true;
          this.selectedValue.push(obj);
        }
      });
    } else {
      this.selectedValue = [];
    }
    // this.onItemSelect.emit(temp)
  }
  syncSelectedValue() {
    if (
      this.controlType === 'checkbox' &&
      this.selectedValue &&
      this.selectedValue.length &&
      this.filteredItems
    ) {
      this.selectedValue.forEach((s: any) => {
        let index = this.filteredItems.findIndex(
          (item: any) => item.label === s.label
        );
        if (index >= 0) {
          this.filteredItems[index]['binary'] = true;
        } else {
          console.log("syncSelectedValue(): Didn't find selected item:", s);
        }
      });
    }
  }
  filterItem(value:string){
    if(!value){
        this.assignCopy();
    }
    if(value && value.length>=2){ // search start only after type 3 character regarding C170665-1013
      this.filteredItems = Object.assign([], this.items).filter(
        item => item.label.toLowerCase().indexOf(value.toLowerCase()) > -1
     )
     this.syncSelectedValue();
    }
  }
}
